import React from 'react';
import { connect } from 'react-redux';

// Components
import { Typography } from '@americanexpress/aqx-components';
import ColorPicker, { parent } from 'src/universal/components/ColorPicker/index.js';
import YourCardBadge from 'src/universal/components/YourCardBadge';

// selectors
import {
  getCardHeadline,
  getCardImageUrl,
  getAnnualFeeText,
  getIsDeltaReserve,
  getCardAltText
} from '../redux';

// styles
import styles from '../__styles__/deltaReserveCardContent.scss?modules';

const DeltaReserveCardContent = ({
  cardHeadline,
  cardArtSrc,
  annualFeeText,
  isDeltaReserve,
  cardAltText
}) => {
  if (!isDeltaReserve) return null;

  return (
    <div className={styles.outerContainer}>
      <YourCardBadge shortName="delta-reserve" isPremium={true} />
      <Typography Component="h1" className={styles.cardHeadlineDesktop}>
        {cardHeadline}
      </Typography>
      <img className={styles.cardArt} src={cardArtSrc} alt={cardAltText} />
      <ColorPicker shortName="delta-reserve" parentType={parent.HERO} />
      <div className={styles.textContainer}>
        <Typography className={styles.annualFeeText}>{annualFeeText}</Typography>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    cardHeadline: getCardHeadline(state),
    cardArtSrc: getCardImageUrl(state),
    annualFeeText: getAnnualFeeText(state),
    isDeltaReserve: getIsDeltaReserve(state),
    cardAltText: getCardAltText(state)
  };
};

export default connect(mapStateToProps)(DeltaReserveCardContent);
